import type { HTMLMotionProps, VariantLabels } from 'framer-motion';
import { motion } from 'framer-motion';
import React from 'react';

const BASE_TRANSITION = {
  type: 'spring',
  stiffness: 1000,
  mass: 1,
  damping: 50,
};

type WithoutNonObjectTypes<Keys extends keyof HTMLMotionProps<'div'>> = {
  [Key in Keys]: Exclude<HTMLMotionProps<'div'>[Key], boolean | VariantLabels>;
};

type ZoomInAnimationProps = Omit<
  HTMLMotionProps<'div'>,
  'initial' | 'animate' | 'exit'
> &
  Partial<WithoutNonObjectTypes<'initial' | 'animate' | 'exit'>> & {
    disabled?: boolean;
  };

const ZoomInAnimation = ({
  children,
  transition,
  initial,
  animate,
  exit,
  disabled,
  ...rest
}: ZoomInAnimationProps) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        scale: 0.8,
        ...initial,
      }}
      animate={{
        opacity: 1,
        scale: 1,
        ...animate,
      }}
      exit={{
        opacity: 0,
        scale: 0.9,
        ...exit,
      }}
      transition={
        disabled ? { duration: 0 } : { ...BASE_TRANSITION, ...transition }
      }
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default ZoomInAnimation;
